<template>
    <Modal
        :show="showModal"
        :title="modalTitle"
        size="large"
        :needFooter="false"
        :needHeader="true"
        :centered="true"
        :closeBtn="true"
        @close="onClose"
        modalClass=""
        bodyClass=""
        class="cemetery-filter-search"
    >
        <form
            autocomplete="off"
            method="get"
            :data-vv-scope="vScope"
            @keyup.enter="() => {return false;}"
            @submit.prevent="() => {return false;}"
        >
            <div class="row">
                <div class="col-12">
                    <component
                        v-bind:is="componentName"
                        v-model="form"
                        :lists="lists"
                        :panelId="panelId"
                        :baseTranslateID="translateID"
                        :readonlyForm="readonlyForm"
                    />
                </div>
            </div>
        </form>

        <template v-slot:modal-footer>
            <div class="modal-footer border-0">
                <div class="row no-gutters w-100 m-0 justify-content-between">
                    <div class="col-12 col-sm-auto">
                        <button
                            class="btn btn-rounded btn-sm btn-responsive btn-outline-main min-w-auto"
                            type="button"
                            @click.prevent="onReset"
                        >
                            {{ $t(`global.clear`) }}
                        </button>
                    </div>
                    <div class="col-12 col-sm-auto">
                        <button
                            class="btn btn-rounded btn-sm btn-responsive btn-main min-w-auto"
                            type="button"
                            @click.prevent="onApply"
                        >
                            {{ $t(`global.apply`) }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import GlobalMixin from '@/app/shared/mixins/global';
import { toCamelCase, nullify } from '@config/utils';

export default {
    mixins: [
        GlobalMixin
    ],
    components: {
        Modal: () => import(/* webpackChunkName: "modal" */ "@/app/shared/components/modals/Modal"),
        SearchSectorsModelForm: () => import(/* webpackChunkName: "cemeteries-searchsectorsmodelform" */ './forms/SearchSectorsModelForm'),
        SearchOccupationsModelForm: () => import(/* webpackChunkName: "cemeteries-searchoccupationsmodelform" */ './forms/SearchOccupationsModelForm'),
        SearchIntermentsModelForm: () => import(/* webpackChunkName: "cemeteries-searchintermentsmodelform" */ './forms/SearchIntermentsModelForm'),
        SearchEntitiesModelForm: () => import(/* webpackChunkName: "cemeteries-searchentitiesmodelform" */ './forms/SearchEntitiesModelForm'),
    },
    provide() {
        return { parentValidator: this.$validator };
    },
    props: {
        panelId: {
            type: String,
            default: null,
        },
        baseTranslateID: {
            type: String,
            default: null,
        },
        showModal: {
            type: Boolean,
            default: false
        },
        vScope: {
            type: String,
            default: 'form'
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
        filters: {
            type: Object,
            default: () => {
                return {};
            }
        },
        lists: {
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    data() {
        return {
            form: {},
        };
    },
    created() {

    },
    beforeDestroy() {

    },
    computed: {
        translateID() {
            return `${this.baseTranslateID ?? this.panelId}`;
        },
        modalTitle() {
            // return this.$t(`${this.translateID}.filter.title`);
            return this.$t(`global.filters`);
        },
        componentName() {
            return `${toCamelCase(this.panelId, true)}ModelForm`
        }
    },
    methods: {
        onClose() {
            this.closeModal();
        },
        closeModal() {
            this.$emit('close')
        },
        onApply() {
            this.$emit('apply', {panelId: this.panelId, form: this.form})
        },
        onReset() {
            this.reset();
        },
        reset() {
            nullify(this.form);
            this.resetValidator();
        },

    },
    watch: {
        filters: {
            immediate: true,
            handler: function(value) {
                this.form = JSON.parse(JSON.stringify(value ?? {}));// Object.assign({}, value ?? {});
            }
        },
    }
};
</script>
